import { RadioInsetBrightcove } from "./radio-inset-brightcove";


export class RadioInits {
    constructor() {
        this.initMap();
    }

    initMap() {
        new RadioInsetBrightcove();
    }
}
